/**
 * @file automatically generated from MApp.Endpoints.MobileClientContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { IImportArea, ISaveArea, IArea, IAreaListItem, IPreviewAreaListItem, ISaveShell, IShellListItem, ISaveDataSource, IDataSourceListItem, IDataSource, IValidationResult } from '../models';

export class MobileClientContentClient extends MetadataClient {

    public static importArea(areaImport: IImportArea) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas/import`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(areaImport)
			})
        );
    }

    public static updateArea(id: string, area: ISaveArea) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(area)
			})
        );
    }

    public static getArea(id: string) {
        return MetadataClient.ajax<IArea>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas/${encodeURIComponent(id)}`)
        );
    }

    public static getAreas() {
        return MetadataClient.ajax<IAreaListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas`)
        );
    }

    public static deleteArea(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static previewAreaImport(areaImport: IImportArea) {
        return MetadataClient.ajax<IPreviewAreaListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/areas/preview`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(areaImport)
			})
        );
    }

    public static saveShell(shell: ISaveShell) {
        return MetadataClient.ajax<IShellListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(shell)
			})
        );
    }

    public static updateShell(id: string, shell: ISaveShell) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(shell)
			})
        );
    }

    public static getShell(id: string) {
        return MetadataClient.ajax<IShellListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells/${encodeURIComponent(id)}`)
        );
    }

    public static getShells() {
        return MetadataClient.ajax<IShellListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells`)
        );
    }

    public static deleteShell(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveDataSource(dataSource: ISaveDataSource) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/datasources`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(dataSource)
			})
        );
    }

    public static updateDataSource(id: string, dataSource: ISaveDataSource) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/datasources/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(dataSource)
			})
        );
    }

    public static getDataSources() {
        return MetadataClient.ajax<IDataSourceListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/datasources`)
        );
    }

    public static getDataSource(id: string) {
        return MetadataClient.ajax<IDataSource>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/datasources/${encodeURIComponent(id)}`)
        );
    }

    public static deleteDataSource(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/datasources/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidShell(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static isValidDataSource(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/datasources/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static getVectorFields(id: string) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/areas/vector/${encodeURIComponent(id)}/fields`)
        );
    }
    
    public static saveShellFiles(formData: FormData, id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/shells/${encodeURIComponent(id)}/upload`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
}
